import { UPCOMING_EVENTS } from '@/data/content';

const statusMap: Record<string, { label: string; className: string }> = {
  upcoming: { label: '即将开放', className: 'bg-border-dark text-text-secondary' },
  open: { label: '报名中', className: 'bg-arena-green/20 text-arena-green' },
  closed: { label: '已截止', className: 'bg-text-disabled/10 text-text-disabled' },
};

export default function EventsPage() {
  return (
    <div className="max-w-6xl mx-auto px-6 pt-8 pb-12">
      {/* ---- Header ---- */}
      <div className="mb-10">
        <h1 className="text-2xl font-extrabold text-text-primary mb-2">赛事与活动</h1>
        <p className="text-sm text-text-secondary">近期赛事安排、合作伙伴与联系方式</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        {/* ---- Events: 2/3 width ---- */}
        <div className="lg:col-span-2">
          <h2 className="text-lg font-extrabold text-text-primary mb-4">近期赛事</h2>
          <div className="space-y-3 mb-8">
            {UPCOMING_EVENTS.map((event, i) => {
              const s = statusMap[event.status];
              return (
                <div key={i} className="flex items-center gap-4 p-4 bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt hover:border-arena-blue/40 transition-all">
                  <div className="text-right shrink-0 w-24">
                    <p className="text-sm font-mono text-arena-gold font-medium">{event.date}</p>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm text-text-primary font-medium">{event.name}</p>
                    <p className="text-xs text-text-secondary mt-1">{event.location}</p>
                  </div>
                  <span className={`text-[10px] px-2.5 py-1 rounded-tag shrink-0 ${s.className}`}>{s.label}</span>
                </div>
              );
            })}
          </div>

          {/* Past Events */}
          <h3 className="text-sm font-semibold text-text-secondary mb-3">往期赛事</h3>
          <div className="space-y-1.5 mb-8">
            {[
              { d: '2026-06-20', n: '2026 春季赛季总决赛', l: '上海', r: '冠军: 铁犀牛 (雷霆战队)' },
              { d: '2026-05-10', n: '华东区校园联赛', l: '杭州', r: '冠军: 闪电侠 (疾风战队)' },
              { d: '2026-04-02', n: '春季赛季开幕赛', l: '广州', r: '冠军: 磐石 (坚盾战队)' },
              { d: '2025-12-15', n: '2025 全国总决赛', l: '深圳', r: '冠军: 暗夜猎手 (夜鹰战队)' },
              { d: '2025-10-08', n: '华北区校园联赛', l: '北京', r: '冠军: 烈焰风暴 (赤焰战队)' },
            ].map((e, i) => (
              <div key={i} className="flex items-center gap-3 px-3 py-2 text-xs text-text-disabled hover:text-text-secondary hover:bg-panel-dark/40 rounded transition-colors">
                <span className="font-mono w-20 shrink-0">{e.d}</span>
                <span className="flex-1">{e.n}</span>
                <span className="w-12 text-right">{e.l}</span>
                <span className="w-44 text-right text-[11px] hidden md:block">{e.r}</span>
              </div>
            ))}
          </div>

          {/* Competition Calendar CTA */}
          <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-5">
            <h3 className="text-sm font-semibold text-text-primary mb-2">主办比赛</h3>
            <p className="text-xs text-text-secondary mb-4 leading-relaxed">学校、机构、场馆可申请成为官方认证赛点。我们提供完整的赛事运营支持——裁判培训、场地搭建指导、裁判系统部署、赛事宣传物料。</p>
            <button className="px-4 h-9 rounded-btn bg-arena-red text-white text-sm hover:brightness-110 transition-all">申请成为赛点</button>
          </div>
        </div>

        {/* ---- Partners + Contact: 1/3 width ---- */}
        <div>
          <h2 className="text-lg font-extrabold text-text-primary mb-4">合作伙伴</h2>
          <div className="grid grid-cols-3 gap-2 mb-5">
            {Array.from({ length: 9 }).map((_, i) => (
              <div key={i} className="aspect-[4/3] rounded-card mecha-card mecha-bolt bg-panel-dark/40 border border-border-dark flex items-center justify-center grayscale hover:grayscale-0 hover:border-arena-blue/40 transition-all cursor-pointer">
                <span className="text-[10px] text-text-disabled">LOGO</span>
              </div>
            ))}
          </div>
          <button className="w-full h-9 rounded-btn border border-arena-blue text-arena-blue text-sm hover:bg-arena-blue/10 transition-all mb-8">成为合作伙伴</button>

          {/* Contact */}
          <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-5 mb-6">
            <h3 className="text-sm font-semibold text-text-primary mb-4">联系我们</h3>
            <div className="space-y-3 text-xs">
              <div>
                <p className="text-text-disabled mb-0.5">商务合作</p>
                <p className="text-text-secondary">biz@modular-robot.cn</p>
              </div>
              <div className="pt-3 border-t border-border-dark">
                <p className="text-text-disabled mb-0.5">赛事咨询</p>
                <p className="text-text-secondary">events@modular-robot.cn</p>
              </div>
              <div className="pt-3 border-t border-border-dark">
                <p className="text-text-disabled mb-0.5">技术支持</p>
                <p className="text-text-secondary">support@modular-robot.cn</p>
              </div>
              <div className="pt-3 border-t border-border-dark">
                <p className="text-text-disabled mb-0.5">媒体合作</p>
                <p className="text-text-secondary">press@modular-robot.cn</p>
              </div>
            </div>
          </div>

          {/* FAQ quick links */}
          <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-5">
            <h3 className="text-sm font-semibold text-text-primary mb-3">常见问题</h3>
            <div className="space-y-2 text-xs">
              {[
                '如何报名参赛？',
                '车辆检录需要准备什么？',
                '团队赛如何组队？',
                '赛点申请条件？',
                '比赛可以录像吗？',
              ].map((q) => (
                <p key={q} className="text-text-secondary hover:text-arena-blue cursor-pointer transition-colors">{q}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
